import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import {
  formatCounterAmount,
  isHourlyFixedBalanceAllowance,
} from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

import { useContractsVersion } from 'modules/timeoff/lib/contractsVersionContext'
import type Allowance from 'modules/timeoff/store/models/Allowance'

interface Props {
  hiredSameYear: boolean
  proratedDays: string | number
  proratedDaysInDecimal: number
  allowance: Allowance
}

const ProratedDays = ({ hiredSameYear, proratedDays, proratedDaysInDecimal, allowance }: Props) => {
  const { startsOn } = useContractsVersion()
  let hiredOn

  if (hiredSameYear) {
    hiredOn = startsOn && dateToString(startsOn, 'ui')
  }

  const allowanceDaysTitle = allowance.isDecimal
    ? i18n.t('time_off.allowance_tooltip.prorated_days_rounded')
    : i18n.t('time_off.allowance_tooltip.prorated_days')

  const title = allowance.isDays
    ? allowanceDaysTitle
    : i18n.t('time_off.allowance_tooltip.prorated_hours')

  const renderProratedDays = allowance.hasProrationEnabled && !allowance.isOvertime

  return (
    <Box>
      {renderProratedDays && (
        <Box>
          {!allowance.isDecimal && (
            <Box flexDirection="row" justifyContent="spaceBetween">
              <Text.Normal color="grey000White">
                {allowance.isHourly
                  ? i18n.t('time_off.allowance_tooltip.prorated_hours_rounded')
                  : i18n.t('time_off.allowance_tooltip.prorated_days_rounded')}
              </Text.Normal>
              <Text.Normal color="grey000White">
                {formatCounterAmount(
                  proratedDaysInDecimal,
                  isHourlyFixedBalanceAllowance(allowance)
                )}
              </Text.Normal>
            </Box>
          )}
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal color="grey000White">{title}</Text.Normal>
            <Text.Normal color="grey000White">{proratedDays}</Text.Normal>
          </Box>
        </Box>
      )}
      {!!hiredOn && (
        <Box flexDirection="row" justifyContent="flexStart">
          <Text.Normal size="200" color="grey000White">
            {i18n.t('time_off.allowance_tooltip.hired', {
              date: hiredOn,
            })}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}

export default observer(ProratedDays)
